import { formatTranslation, issueLastDecisionStatusLabelKey } from 'intl';
import { IssueTranslationKeys } from 'intl/keys';
import { LastDecisionStatus } from 'shared/domain/workflow/lastDecisionStatus';
import { createEntityFilterInput } from '../common';

export const LastDecisionFilterInput = createEntityFilterInput({
  useData: () => Object.values(LastDecisionStatus),
  transformData: (statuses, intl) =>
    statuses.map((status) => ({
      _id: status,
      label: formatTranslation(intl, issueLastDecisionStatusLabelKey(status)),
    })),
  labelId: IssueTranslationKeys.columnHeaderLastDecision,
  id: 'last-decision-filter',
});
